import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";

function SearchUser() {
  const [userName, setUserName] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        if (result && result.status_code === 200 && result.data) {
          setWebSetting(result.data);
        }
      } catch (error) {
        return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ." });
      }
    };
    fetchData();
  }, []);

  const checkUser = async () => {
    if (!userName) {
      return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
    } else {
      let result = await apiCheckAccount(userName);
      if (result && result?.code === 200) {
        let data = result.data;
        navigate("/profile", { state: { userName, data, webSetting } });
      }
    }
  };

  return (
    <div
    >
      <div className='w-full h-fit flex justify-center items-center'>
        <img src="/search/title-sup-cskh.png" alt="logo" className='w-full md:max-w-[300px] max-w-[200px] h-auto object-contain' />
      </div>
      <p className="md:text-[18px] text-[14px] font-Inter text-[#202020] font-[600]  tracking-wide text-center">VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</p>
      <div className="mt-[15px] flex items-center gap-2 relative">
        <div className="h-12 flex items-center justify-between rounded-[30px] pl-12 pr-3 border border-[#C7C7C7] relative w-full bg-white box-border">
          <svg className="absolute left-4 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input className="border-none outline-none bg-transparent text-[#8e8e8e] text-base h-full w-full italic placeholder:italic"
            onChange={(e) => setUserName(e.target.value.toLowerCase().trim())}
            type="text"
            placeholder="Nhập tên tài khoản"
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='w-5 h-5'>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.236 3.4723C12.4929 3.72794 12.494 4.14345 12.2383 4.40038L8.80076 7.85522L12.2777 11.3496C12.5333 11.6065 12.5323 12.0221 12.2754 12.2777C12.0185 12.5333 11.6029 12.5323 11.3473 12.2754L7.875 8.78563L4.4027 12.2754C4.14706 12.5323 3.73155 12.5333 3.47462 12.2777C3.2177 12.0221 3.21666 11.6065 3.4723 11.3496L6.94924 7.85522L3.51166 4.40038C3.25602 4.14346 3.25706 3.72794 3.51399 3.4723C3.77091 3.21666 4.18642 3.21771 4.44206 3.47463L7.875 6.92481L11.3079 3.47462C11.5636 3.2177 11.9791 3.21666 12.236 3.4723Z" fill="#6A7282" />
          </svg>
        </div>
        <button
          className="h-12 px-4 py-2.5 flex items-center justify-center text-white text-[14px] md:text-[16px] font-inter font-semibold tracking-wide border-2 border-white rounded-[30px] w-fit cursor-pointer whitespace-nowrap text-center"
          style={{
            background: "var(--chon, linear-gradient(0deg, #1E6FFF 0%, #7DACFF 100%))",
            boxShadow: "0 0.984px 0.492px 0.049px rgba(29, 41, 61, 0.02) inset"
          }}
          onClick={checkUser}
        >
          Kiểm tra
        </button>
      </div>
      <div className="mt-5 text-center">
        <div className="mt-[30px] rounded-[10px] border-2 border-[#DCDFE3] bg-cover p-[10px_15px] relative">
          {webSetting && webSetting.login_info_notice ? (
            <div className="[&>p]:font-medium [&>p]:text-base [&>p]:leading-[150%] [&>p]:text-justify [&>p]:text-[#36a638]"
              dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }} />
          ) : null}
        </div>
      </div>
      <div className="hidden md:block w-full mt-5">
        <img 
          src="/bg/bg-bottom.png" 
          alt="footer" 
          className='max-w-full md:max-w-[640px] sm:max-w-[480px] h-auto object-contain mx-auto block'
          style={{ imageRendering: 'crisp-edges' }}
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default SearchUser;
